<div *ngIf="expire" class="expire-mss">
  <p>{{ 'common.streamTimedOut' | t }}</p>
  <sn-outline-button (click)="getNewUrl()">{{ 'common.refresh' | t }}</sn-outline-button>
</div>
<div *ngIf="startExpire" class="expire-mss start">
  <countdown [config]="{ leftTime: 30, format: 's' }" (event)="timeIsEnd($event)"></countdown>
  <p>{{ 'common.areYouStillWatching' | t }}</p>
  <sn-outline-button (click)="initialization()">{{ 'common.yes' | t }}</sn-outline-button>
</div>

<sn-player
  #player
  [width]="width"
  [height]="height"
  [caption]="caption"
  [elevation]="elevation"
  [fullscreen]="fullscreen"
  [aspectRatio]="aspectRatio"
  [state]="state$ | async"
  toastContainer
  [ngClass]="{ fullscreenVideo: fullscreen }"
>
  <div
    *ngIf="!!time"
    snTimestamp
    class="sn-player__timestamp"
    [ngClass]="{ 'timestamp__hide-controls': isHidden, 'timestamp__expand-controls': !isHidden }"
  >
    <div class="timestamp__zoom">
      <div class="test" id="timestamp-display" #timeStampDisplay></div>
    </div>
    <div>
      <sn-icon-button
        (click)="toggleControls()"
        [matTooltip]="'common.hideTimestamp' | t"
        matTooltipPosition="left"
      >
        <sn-icon>arrow_right_alt</sn-icon>
      </sn-icon-button>
    </div>
  </div>
  <div snPlayerContent #playerContent class="sn-video-player__content">
    <ng-template [ngIf]="isHls && (!fragLoaded || !levelLoaded)" [ngIfThen]="loading"></ng-template>
    <ng-template [ngIf]="isLoading" [ngIfThen]="loading"></ng-template>
    <ng-content select="[snPlayerContent]"></ng-content>
  </div>
  <div snWatermarkContent #watermarkContent>
    <div
      *ngIf="
        (currentOrganization.settings.enableVideoWatermarking && live) ||
        (currentOrganization.settings.enablePlaybackWatermarking && !live)
      "
      class="waterMarker"
      [ngClass]="{ 'full-screen': fullscreen }"
    >
      <p *ngIf="currentEmailUser">{{ currentEmailUser }}</p>
    </div>
  </div>
  <div snPlayerFooter class="sn-video-player__footer" *ngIf="reference && controls">
    <div
      *ngIf="fullscreen && !!time"
      [matTooltip]="'common.showTimestamp' | t"
      matTooltipPosition="left"
      class="tab-container ts-tab-container"
      (click)="toggleControls()"
      [ngClass]="{ 'show-tab': !tabHidden }"
    >
      <sn-icon class="tools-tab">more_vert</sn-icon>
    </div>
    <ng-content></ng-content>
  </div>
</sn-player>

<ng-template #loading>
  <div class="sn-video-player__loader">
    <img src="/assets/fusus-icons/fusus-animation.gif" width="128" [alt]="'common.loading' | t" />
  </div>
</ng-template>
